export default [
  {
    'text': '운영중',
    'state': 'RUNNING'
  },
  {
    'text': '점검중',
    'state': 'MAINTENANCE'
  },
  {
    'text': '운영시간아님',
    'state': 'CLOSED'
  },
];



// WEBPACK FOOTER //
// ./src/api/serverState.js